import { CheckoutSessionCriteria, formatMoney, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const checkoutSessionDetailsColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.26,
    field: 'checkout_session_details_value',
    headerName: <Text tId={'DETAILS'} />,
    align: 'left',
    renderCell: (rowData: { row: CheckoutSessionCriteria }) => {
      const isCreditCard =
        rowData.row.paymentMethods?.length === 1 &&
        rowData.row.paymentMethods.some((paymentMethod) => paymentMethod === PaymentMethodType.CREDIT_CARD);

      // Maybe add card type to CheckoutSessionCriteria in order to be able to print it?
      if (isCreditCard) {
        return (
          <div style={{ minWidth: 0, lineHeight: 'normal' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gridGap: 2 }}>
              <div className="overflow-text-ellipsis">{rowData.row.cart.description}</div>
            </div>
          </div>
        );
      }

      return (
        <div style={{ minWidth: 0, lineHeight: 'normal' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gridGap: 2 }}>
            <div className="overflow-text-ellipsis">{rowData.row.cart.merchantOrderReference1}</div>
            <div>
              {formatMoney({
                value: rowData.row.principal.amount - rowData.row.downPayment.amount.amount,
                currency: rowData.row.principal.currency,
              })}
            </div>
          </div>
        </div>
      );
    },
  };
};
